const home = {
  // Hero
  hero_headline_1: 'Die Führung, die Ihre',
  hero_headline_family: 'Familie',
  hero_headline_and: 'und',
  hero_headline_school: 'Schule',
  hero_headline_2: 'brauchen',
  hero_description: 'Transformieren Sie Ihre Familienbeziehungen und das Bildungsmanagement mit Methoden, die durch <strong>17 Jahre Erfahrung</strong> erprobt sind. Entdecken Sie den Weg zu einer Führung, die echte und dauerhafte Ergebnisse erzielt.',
  hero_btn_books: 'Bücher',
  hero_btn_courses: 'Kurse',
  hero_btn_mentorship: 'Mentoria SÍLEX',
  hero_stat_experience: 'Jahre Erfahrung',
  hero_stat_mba: 'USP/Esalq',

  // Books section
  books_title: 'Bücher und Werke:',
  books_title_highlight: 'Der Beginn der Transformation',
  books_subtitle: 'Bücher und E-Books, die bereits Tausende von Familien und Bildungsfachleuten in ganz Brasilien transformiert haben',
  books_format: 'PDF E-Book',
  books_btn_buy: 'Kaufen',
  books_btn_details: 'Details anzeigen',
  books_guarantee: '7-Tage-Garantie',
  books_coming_soon: 'Demnächst',
  books_coming_new: 'Neuer Titel demnächst',
  books_coming_desc: 'Wir bereiten noch mehr großartige Inhalte für Sie vor!',
  books_notify_label: 'Benachrichtigen bei Start',
  books_details_hover: 'Details anzeigen',

  // Courses section
  courses_title: 'Elite-Ausbildung:',
  courses_title_highlight: 'Die vollständige Methode',
  courses_subtitle: 'Strukturierte Online-Kurse mit Methoden, die durch über 17 Jahre praktische Erfahrung validiert wurden',
  courses_badge: 'Online-Kurs',
  courses_modules: 'Module',
  courses_btn_enroll: 'Jetzt einschreiben',
  courses_btn_details: 'Details anzeigen',
  courses_guarantee: '30-Tage-Garantie',
  courses_coming_new: 'Neuer Kurs demnächst',
  courses_coming_desc: 'Wir bereiten eine neue großartige Ausbildung für Sie vor!',
  courses_students: 'Studenten',
  courses_or: 'oder',
  courses_hover_view: 'Kurs ansehen',
  courses_testimonials_title: 'Was unsere Studenten sagen',

  // SÍLEX Showcase (Vitrine SÍLEX na Home) — i18n: PT provisório (traduzir)
  silex_showcase_eyebrow: 'Método SÍLEX · 48 etapas',
  silex_showcase_title: 'Mentoria',
  silex_showcase_title_highlight: 'SÍLEX',
  silex_showcase_subtitle: 'Para pais e educadores que decidiram parar de disputar atenção — e começar a reconstruir presença, respeito e direção.',
  silex_showcase_body: 'Um método de cinco pilares para substituir o ruído dos confrontos pela clareza do diálogo, instalando uma aliança de respeito mútuo e engajamento prático entre pais, educadores e jovens.',
  silex_showcase_benefits_kicker: 'O que você recebe',
  silex_showcase_benefit_1_title: 'Método completo em 48 etapas',
  silex_showcase_benefit_1_desc: 'As 48 etapas do método, do diagnóstico à consolidação. Presente nos três planos, sem versão reduzida.',
  silex_showcase_benefit_2_title: 'Liberação por conclusão, não por calendário',
  silex_showcase_benefit_2_desc: 'Cada etapa abre quando a anterior é concluída. Você avança no seu ritmo, sem pular fundamento.',
  silex_showcase_benefit_3_title: 'Lives coletivas com o mentor',
  silex_showcase_benefit_3_desc: 'Três no Spark, seis no Lab, quinzenais no Protag. Encontros ao vivo para tirar dúvidas e ver o método aplicado a casos reais.',
  silex_showcase_benefit_4_title: 'Encontros individuais',
  silex_showcase_benefit_4_desc: 'Dois no Lab, de dois a quatro no Protag. Sessões reservadas ao seu cenário específico.',
  silex_showcase_benefit_5_title: 'Suporte no canal do seu plano',
  silex_showcase_benefit_5_desc: 'Pela plataforma no Spark, em grupo no Lab, direto no WhatsApp no Protag.',
  silex_showcase_benefit_6_title: 'Acesso por tempo definido',
  silex_showcase_benefit_6_desc: '90 dias no Spark, 180 no Lab, 365 no Protag. Compra única, sem assinatura e sem renovação automática.',
  silex_showcase_cta_secondary: 'Ver planos e detalhes',
  silex_showcase_plans_kicker: 'Conheça os três planos',
  silex_showcase_plan_spark_name: 'SÍLEX Spark',
  silex_showcase_plan_spark_price: 'R$ 997',
  silex_showcase_plan_spark_duration: '90 dias',
  silex_showcase_plan_spark_tagline: 'Começar com clareza',
  silex_showcase_plan_lab_name: 'SÍLEX Lab',
  silex_showcase_plan_lab_price: 'R$ 2.997',
  silex_showcase_plan_lab_duration: '180 dias',
  silex_showcase_plan_lab_tagline: 'Implementar com consistência',
  silex_showcase_plan_protag_name: 'SÍLEX Protag',
  silex_showcase_plan_protag_price: 'R$ 8.997',
  silex_showcase_plan_protag_duration: '365 dias',
  silex_showcase_plan_protag_tagline: 'O caminho principal',
  silex_showcase_plan_protag_highlight: 'Recomendado',
  silex_showcase_plan_duration_label: 'de acesso',
  silex_showcase_plan_card_cta: 'Ver detalhes',
  silex_showcase_plans_note: 'Opções de parcelamento disponíveis no checkout.',
  silex_showcase_guarantee_title: 'Garantia SÍLEX de Clareza e Aplicação',
  silex_showcase_guarantee_text: 'Sete dias para verificar se a estrutura faz sentido para o seu contexto. Se não fizer, o cancelamento é seu direito, sem burocracia.',
  silex_showcase_cta_primary: 'Conhecer a Mentoria SÍLEX',

  // Action Center
  action_title: 'Ihr nächster Schritt:',
  action_title_highlight: 'Aktionszentrum',
  action_subtitle: 'Wählen Sie den idealen Weg für Ihre Transformation',
  action_quick_title: 'Schnellstart',
  action_quick_desc: 'Beginnen Sie noch heute mit unseren E-Books und transformieren Sie Ihr Management',
  action_quick_btn: 'Bücher ansehen',
  action_deep_title: 'Vollständige Ausbildung',
  action_deep_desc: 'Meistern Sie alle Strategien mit unseren strukturierten Kursen',
  action_deep_btn: 'Kurse ansehen',
  action_deep_badge: 'BELIEBTESTE',
  action_elite_title: 'Elite-Zugang',
  action_elite_desc: 'Exklusives Mentoring für außergewöhnliche Ergebnisse',
  action_faq_title: 'Häufig gestellte Fragen',
  action_faq_q1: 'Wie funktioniert der Zugang zu den Kursen?',
  action_faq_a1: 'Nach dem Kauf erhalten Sie sofortigen und lebenslangen Zugang zum vollständigen Inhalt, sodass Sie in Ihrem eigenen Tempo lernen können.',
  action_faq_q2: 'Sind die E-Books physisch oder digital?',
  action_faq_a2: 'Alle unsere Bücher sind im digitalen PDF-Format, was sofortigen Zugang nach dem Kauf ermöglicht.',
  action_faq_q3: 'Was ist der Unterschied zwischen Kursen und Mentoring?',
  action_faq_a3: 'Kurse sind strukturierte Inhalte für selbstständiges Lernen. Mentoring ist eine personalisierte und exklusive Einzelbegleitung.',
  action_faq_q4: 'Gibt es eine Zufriedenheitsgarantie?',
  action_faq_a4: 'Ja! Wir bieten 7 Tage Garantie für E-Books und 30 Tage für Kurse. Wenn Sie nicht zufrieden sind, erstatten wir Ihre Investition.',
  action_faq_q5: 'Wie funktioniert der Bewerbungsprozess für Mentoring?',
  action_faq_a5: 'Nach dem Ausfüllen des Formulars analysiert unser Team Ihr Profil und meldet sich innerhalb von 24 Stunden, um ein Gespräch zu vereinbaren.',
  action_cta_title: 'Bereit, Ihre Führung zu transformieren?',
  action_cta_desc: 'Schließen Sie sich den Fachleuten an, die ihr Leben bereits mit unseren Methoden transformiert haben',
  action_cta_btn_explore: 'Produkte erkunden',

  // Social Proof
  social_title: 'Exklusiver Inhalt auf Instagram',
  social_subtitle: 'Folgen Sie Inhalten zu Bildungsmanagement und Familienbeziehungen',
  social_follow: 'Jetzt folgen',

  // Footer
  footer_partner_label: 'Projeto parceiro',
  footer_partner_name: 'Protocolo & Conexão',
  footer_partner_desc: 'Palestras e formações para escolas, famílias e empresas.',
  footer_partner_cta: 'Conhecer o projeto',
  footer_brand_desc: 'Bildungsführer und Familien durch bewährte Methoden seit über 17 Jahren transformieren.',
  footer_products_title: 'Produkte',
  footer_products_books: 'Bücher & E-Books',
  footer_products_courses: 'Online-Kurse',
  footer_products_talks: 'Unternehmensvorträge',
  footer_products_webinars: 'Live-Webinare',
  footer_company_title: 'Unternehmen',
  footer_company_about: 'Über uns',
  footer_company_contact: 'Kontakt',
  footer_support_title: 'Support',
  footer_support_help: 'Hilfezentrum',
  footer_support_privacy: 'Datenschutzrichtlinie',
  footer_support_terms: 'Nutzungsbedingungen',
  footer_support_refund: 'Rückerstattung anfragen',
  footer_copyright: '© {{ano}} SB Family & Mastery. Alle Rechte vorbehalten.',
  footer_secure: 'Sichere Website',
  footer_payment: 'Geschützter Zahlungsverkehr',

  // FAQ Page
  faq_badge: 'Hilfezentrum',
  faq_title: 'Wie können wir helfen?',
  faq_subtitle: 'Finden Sie Antworten auf die häufigsten Fragen zur Plattform, Kursen, Zahlungen und Zertifikaten.',
  faq_cat_geral: 'Allgemein',
  faq_cat_acesso: 'Zugang & Konto',
  faq_cat_cursos: 'Kurse',
  faq_cat_pagamento: 'Zahlung',
  faq_cat_certificado: 'Zertifikate',
  faq_cat_mentoria: 'Mentoring',
  faq_not_found_title: 'Nicht gefunden, was Sie gesucht haben?',
  faq_not_found_desc: 'Unser Support-Team steht Ihnen von Montag bis Freitag von 8 bis 18 Uhr zur Verfügung.',
  faq_not_found_btn: 'Mit dem Support sprechen',

  // Cursos Page
  cursos_badge: 'Elite-Programme',
  cursos_title: 'Kurs-',
  cursos_title_highlight: 'Katalog',
  cursos_subtitle: 'Bewährte Methoden zur Transformation Ihres Bildungsmanagements und Ihrer Familienbeziehungen.',
  cursos_stat_courses: 'Kurse verfügbar',
  cursos_stat_rating: 'Durchschnittsbewertung 4.8',
  cursos_stat_guarantee: '30-Tage-Garantie',
  cursos_search_placeholder: 'Kurse suchen...',
  cursos_filter_all_areas: 'Alle Bereiche',
  cursos_filter_all_levels: 'Alle Niveaus',
  cursos_filter_all_durations: 'Beliebige Dauer',
  cursos_filter_clear: 'Löschen',
  cursos_results_found_one: 'Kurs gefunden',
  cursos_results_found_many: 'Kurse gefunden',
  cursos_results_none: 'Keine Kurse gefunden',
  cursos_no_results_title: 'Keine Ergebnisse gefunden',
  cursos_no_results_desc: 'Versuchen Sie, Filter anzupassen oder mit anderen Suchbegriffen zu suchen.',
  cursos_no_results_btn: 'Filter löschen',
  cursos_badge_online: 'Online-Kurs',
  cursos_modules_label: 'Module',
  cursos_enroll_btn: 'Jetzt einschreiben',
  cursos_details_btn: 'Details anzeigen',
  cursos_view_btn: 'Kurs ansehen',
  cursos_cta_title: 'Möchten Sie schnellere Ergebnisse?',
  cursos_cta_desc: 'Premium Mentoring ist der direkteste Weg, Ihre Schule oder Familie mit personalisierter Begleitung zu transformieren.',
  cursos_students_label: 'Studenten',
  cursos_or_label: 'oder',

  // Sobre Page
  sobre_badge: 'Über uns',
  sobre_title: '17 Jahre der Führungskräfteentwicklung',
  sobre_subtitle: 'SB Family & Mastery entstand aus der Überzeugung, dass echte Führung zu Hause beginnt und sich auf Institutionen ausweitet. Wir sind eine Executive Education Plattform mit einer klaren Mission: Familien und Schulen durch anwendbares Wissen zu transformieren.',
  sobre_mission_label: 'Unsere Mission',
  sobre_vision_label: 'Unsere Vision',
  sobre_purpose_label: 'Unser Zweck',
  sobre_mission_text: 'Bildungs- und Familienführer mit praktischen Tools und bewährten Methoden auszustatten, die eine echte und messbare Transformation im Leben von Menschen und Institutionen bewirken.',
  sobre_vision_text: 'Die führende Referenz für Executive Education im Familien- und Schulmanagement in Brasilien zu sein und eine Generation von Führungskräften zu formen, die bleibende Vermächtnisse aufbauen.',
  sobre_purpose_text: 'Wir glauben, dass jede gestärkte Familie und jede gut verwaltete Schule Wellen positiver Auswirkungen erzeugt, die Generationen überdauern. Deshalb tun wir, was wir tun.',
  sobre_values_title: 'Unsere Werte',
  sobre_values_desc: 'Die Säulen, die jede Entscheidung, jeden Inhalt und jede Interaktion unseres Teams leiten.',
  sobre_team_badge: 'Wer dahintersteckt',
  sobre_team_title: 'Unser Gründungsteam',
  sobre_team_desc: 'Fachleute mit fundierter kombinierter Erfahrung in Bildung, Psychologie und Technologie.',
  sobre_timeline_title: 'Unsere Reise',
  sobre_timeline_desc: '17 Jahre Geschichte, Lernen und Wirkung.',
  sobre_cta_title: 'Werden Sie Teil der Transformation',
  sobre_cta_desc: 'Schließen Sie sich den Familien und Pädagogen an, die sich bereits für das Wachstum mit SB Family & Mastery entschieden haben.',
  sobre_cta_contact: 'Kontaktieren Sie uns',

  // Contato Page
  contato_badge: 'Kontaktieren Sie uns',
  contato_title: 'Wir sind für Sie da',
  contato_subtitle: 'Unser Support-Team antwortet innerhalb von 24 Arbeitsstunden. Wählen Sie den bequemsten Kanal für Sie.',
  contato_form_title: 'Eine Nachricht senden',
  contato_form_desc: 'Füllen Sie das Formular aus und wir melden uns innerhalb von 24 Arbeitsstunden.',
  contato_name_label: 'Vollständiger Name *',
  contato_email_label: 'E-Mail *',
  contato_subject_label: 'Betreff',
  contato_message_label: 'Nachricht *',
  contato_send_btn: 'Nachricht senden',
  contato_sending: 'Wird gesendet...',
  contato_success_title: 'Nachricht gesendet!',
  contato_success_desc: 'Unser Team meldet sich innerhalb von 24 Arbeitsstunden bei Ihnen.',
  contato_success_new: 'Neue Nachricht senden',
  contato_error: 'Fehler beim Senden. Versuchen Sie es erneut oder nutzen Sie einen anderen Kanal.',
  contato_faq_title: 'Schnelle Fragen',
  contato_faq_desc: 'Ihre Frage ist vielleicht schon in unserem FAQ beantwortet:',
  contato_faq_all: 'Gesamtes Hilfezentrum anzeigen',
  contato_hours_title: 'Öffnungszeiten',
  contato_online: 'Support jetzt online',
  contato_hours_weekday: 'Montag – Freitag',
  contato_hours_weekday_val: '8 bis 18 Uhr',
  contato_hours_saturday: 'Samstag',
  contato_hours_saturday_val: '9 bis 13 Uhr',
  contato_hours_sunday: 'Sonntag und Feiertage',
  contato_hours_sunday_val: 'Geschlossen',
};

export default home;
